import { MenuItemKey } from "../../Layout/Sidebar/MenuItemKey";
import EditUserPreferenceWorkplacePreferences from "../../../Pages/Flex/UserPreferences/EditWorkplacePreferences/EditWorkplacePreferences";
import EditUserPreferenceNotifications from "../../../Pages/Flex/UserPreferences/EditNotifications/EditNotifications";
import EditUserPreferenceAccountSettings from "../../../Pages/Flex/UserPreferences/EditAccountSettings/EditAccountSettings";
import CreateRecurringBookings from "../../../Pages/Flex/Bookings/CreateRecurring/CreateRecurringBookings";
import FlexHome from "../../../Pages/Flex/Shared/Home/FlexHome";
import SearchColleague from "../../../Pages/Flex/Users/SearchColleague/SearchColleague";
import EditUserPreferenceCostCodes from "../../../Pages/Flex/UserPreferences/EditCostCodes/EditCostCodes";
import ViewSchedule from "../../../Pages/Flex/Bookings/ViewSchedule/ViewSchedule";
import ListDelegates from "../../../Pages/Flex/Delegates/List/ListDelegates";
import FlexCreateManyDelegates from "../../../Pages/Shared/Delegates/CreateMany/CreateManyDelegates";
import ListTasks from "../../../Pages/Shared/Tasks/List/ListTasks";
import ListVisits from "../../../Pages/Shared/Visits/List/ListVisits";
import EditVisit from "../../../Pages/Shared/Visits/Edit/EditVisit";
import EditTask from "../../../Pages/Shared/Tasks/Edit/EditTask";
import ListBookings from "../../../Pages/Shared/Bookings/List/ListBookings";
import SearchSpaces from "../../../Pages/Shared/Spaces/Search/SearchSpaces";
import EditBooking from "../../../Pages/Shared/Bookings/Edit/EditBooking";
import ViewBookingSeries from "../../../Pages/Shared/BookingSeries/View/ViewBookingSeries";
import EditCateringOrder from "../../../Pages/Shared/CateringOrders/Edit/EditCateringOrder";
import { IRoute } from "./IbssRouter";
import EventDetails from "../../../Pages/Flex/Events/View/EventDetails";
import ListEvents from "../../../Pages/Flex/Events/List/ListEvents";
import MyNotifications from "../../../Pages/Flex/Notifications/List/FlexNotifications";
import { rights } from "../../../Common/RightsManager";
import EditEvents from "../../../Pages/OneLens/Events/Edit/EditEvents";
export default class FlexRoutes
{
    public routes: IRoute[] = [
        {
            isAuthorised: () => rights.FLEX.MySchedule.MyBookings.has(),
            path: '/flex/bookings/mine',
            legacyPaths: [{ path: "/flex-my-bookings" }],
            component: ListBookings,
            menuItemId: MenuItemKey.Flex_MySchedule_MyBookings
        },
        {
            isAuthorised: () => rights.FLEX.MySchedule.MyBookings.has(),
            path: "/flex-my-bookings/:buildingid/mybooking/:bookingid/:spaceId",
            component: EditBooking,
            menuItemId: MenuItemKey.Flex_MySchedule_MyBookings
        },
        {
            isAuthorised: () => rights.FLEX.MySchedule.MyBookingsForOthers.has(),
            path: '/flex/bookings/for-others',
            legacyPaths: [{ path: "/flex-my-bookings-for-others" }],
            component: ListBookings,
            menuItemId: MenuItemKey.Flex_MySchedule_MyBookingsForOthers
        },
        {
            isAuthorised: () => rights.FLEX.MySchedule.MyBookingsForOthers.has(),
            path: "/flex/bookings-for-others/:buildingId/booking-series/view/:seriesId",
            component: ViewBookingSeries,
            menuItemId: MenuItemKey.Flex_MySchedule_MyBookingsForOthers
        },
        {
            isAuthorised: () => rights.FLEX.MySchedule.MyBookings.has(),
            path: "/flex/bookings/primaries",
            component: ListBookings,
            menuItemId: MenuItemKey.Flex_MySchedule_PrimaryBookings
        },
        {
            isAuthorised: () => rights.FLEX.MySchedule.MyBookings.has(),
            path: "/flex/bookings/primaries/:buildingid/mybooking/:bookingid/:spaceId",
            component: EditBooking,
            menuItemId: MenuItemKey.Flex_MySchedule_MyBookings
        },
        {
            isAuthorised: () => rights.FLEX.MySchedule.MyBookings.has(),
            path: "/flex/bookings/:buildingId/booking-series/view/:seriesId",
            component: ViewBookingSeries,
            menuItemId: MenuItemKey.Flex_MySchedule_MyBookings
        },
        {
            isAuthorised: () => rights.FLEX.MySchedule.MyBookingsForOthers.has(),
            path: "/flex-my-bookings-for-others/:buildingid/mybookingother/:bookingid/:spaceId",
            component: EditBooking,
            menuItemId: MenuItemKey.Flex_MySchedule_MyBookingsForOthers
        },
        {
            isAuthorised: () => rights.FLEX.MySchedule.MyBookings.has(),
            path: "/flex-my-bookings/:buildingid/mybooking/catering/:bookingid/:cateringOrderId/edit",
            component: EditCateringOrder,
            menuItemId: MenuItemKey.Flex_MySchedule_MyBookings
        },
        {
            isAuthorised: () => rights.FLEX.MySchedule.MyBookings.has(),
            path: "/create-catering-order/:buildingid/:bookingid/:spaceId",
            component: EditCateringOrder,
            menuItemId: MenuItemKey.Flex_MySchedule_MyBookings
        },
        {
            isAuthorised: () => rights.FLEX.SearchSpaces.Single.has(),
            path: "/flex-my-bookings/:buildingid/catering/:bookingid/:cateringOrderId/edit",
            component: EditCateringOrder,
            menuItemId: MenuItemKey.Flex_MySchedule_MyBookings
        },
        {
            isAuthorised: () => rights.FLEX.MySchedule.MyVisitors.has(),
            path: '/flex/visits/:visit_Id/edit',
            legacyPaths: [{ path: "/flex-my-visitor/:buildingid/myvisit/:visit_Id", parameterMap: { buildingid: 'building' } }],
            component: EditVisit,
            menuItemId: MenuItemKey.Flex_MySchedule_MyVisitors
        },
        {
            isAuthorised: () => rights.FLEX.MySchedule.MyVisitors.has(),
            path: '/flex/visits',
            legacyPaths: [{ path: "/flex-my-visitor" }],
            component: ListVisits,
            menuItemId: MenuItemKey.Flex_MySchedule_MyVisitors
        },
        {
            isAuthorised: () => rights.FLEX.UserPreferences.Workplace.has(),
            path: "/flex-user-pref-workplace",
            component: EditUserPreferenceWorkplacePreferences,
            menuItemId: MenuItemKey.Flex_Settings_Workplace
        },
        {
            isAuthorised: () => rights.FLEX.UserPreferences.has(),
            path: "/flex-user-pref-notifications",
            component: EditUserPreferenceNotifications,
            menuItemId: MenuItemKey.Flex_Settings_Notifications
        },
        {
            isAuthorised: () => rights.FLEX.UserPreferences.AccountSettings.has(),
            path: "/flex-user-pref-account",
            component: EditUserPreferenceAccountSettings,
            menuItemId: MenuItemKey.Flex_Settings_Account
        },
        {
            isAuthorised: () => rights.FLEX.UserPreferences.CostCodes.has(),
            path: "/flex/settings/default-cost-codes",
            component: EditUserPreferenceCostCodes,
            menuItemId: MenuItemKey.Flex_Settings_CostCodes
        },
        {
            isAuthorised: () => rights.FLEX.UserPreferences.Delegates.has(),
            path: "/flex/delegates/create",
            component: FlexCreateManyDelegates,
            menuItemId: MenuItemKey.Flex_Settings_DelegatePermissions
        },
        {
            isAuthorised: () => rights.FLEX.UserPreferences.Delegates.has(),
            path: "/flex/delegates",
            component: ListDelegates,
            menuItemId: MenuItemKey.Flex_Settings_DelegateAccess
        },
        {
            isAuthorised: () => rights.FLEX.MyTasks.MyTasks.has(),
            path: "/flex-my-tasks",
            component: ListTasks,
            menuItemId: MenuItemKey.Flex_MyTask_TasksRaised
        },
        {
            isAuthorised: () => rights.FLEX.MyTasks.MyTasks.has(),
            path: "/flex-my-tasks/:tab",
            component: ListTasks,
            menuItemId: MenuItemKey.Flex_MyTask_TasksRaised
        },
        {
            isAuthorised: () => rights.FLEX.MyTasks.MyTasks.has(),
            path: "/flex-my-tasks/:buildingid/mytask/:task_Id",
            component: EditTask,
            menuItemId: MenuItemKey.Flex_MyTask_TasksRaised
        },
        {
            isAuthorised: () => rights.FLEX.SearchSpaces.Single.has(),
            path: '/flex/spaces/search',
            legacyPaths: [{ path: '/flex-find-a-space' }],
            component: SearchSpaces,
            menuItemId: MenuItemKey.Flex_FindASpace_Single
        },
        {
            isAuthorised: () => rights.FLEX.SearchSpaces.Single.has(),
            path: "/flex-find-a-space/:buildingid/:searchaspace/:spaceId",
            component: EditBooking,
            menuItemId: MenuItemKey.Flex_FindASpace_Single
        },
        {
            isAuthorised: () => rights.FLEX.SearchSpaces.Single.has(),
            path: "/flex/schedule-view",
            component: ViewSchedule,
            menuItemId: MenuItemKey.Flex_Schedule
        },
        {
            isAuthorised: () => rights.FLEX.SearchSpaces.Advanced.has(),
            path: "/flex-recurring-booking",
            component: CreateRecurringBookings,
            menuItemId: MenuItemKey.Flex_FindASpace_Recurring
        },
        {
            isAuthorised: () => true,
            path: "/flex-home/",
            component: FlexHome,
            menuItemId: MenuItemKey.Flex_Home
        },
        {
            isAuthorised: () => true,
            path: "/flex-my-notification",
            component: MyNotifications,
            menuItemId: MenuItemKey.Flex_MyNotification
        },
        {
            isAuthorised: () => rights.FLEX.Search.People.has(),
            path: "/flex/users/search-colleagues",
            component: SearchColleague,
            menuItemId: MenuItemKey.Flex_FindAColleague
        },
        {
            isAuthorised: () => rights.FLEX.Events.View.has(),
            path: "/flex/events/mine",
            component: ListEvents,
            menuItemId: MenuItemKey.Flex_MyEvents
        },
        {
            isAuthorised: () => rights.FLEX.Events.View.has(),
            path: "/flex/events/:eventId/:buildingid",
            component: EventDetails,
            menuItemId: MenuItemKey.Flex_MyEvents
        },
        {
            isAuthorised: () => rights.FLEX.Events.View.has(),
            path: "/flex/events/:buildingid/:bookingid/:spaceid",
            component: EditEvents,
            menuItemId: MenuItemKey.Flex_MyEvents
        },
        {
            isAuthorised: () => rights.FLEX.Events.View.has(),
            path: "/flex/events/:buildingid/:bookingid/:spaceid/:eventid",
            component: EditEvents,
            menuItemId: MenuItemKey.Flex_MyEvents
        },
    ];
}
